module.exports = __webpack_public_path__ + "media/images/sp/specials/fair/bg_04-bd0d18d7d9cf92a3968f23895be19bb8.jpg";